import { Option } from "@src/deprecatedDesignSystem/components/ToggleGroup";
import { useMemo } from "react";
import { createEnumParam, useQueryParam, withDefault } from "use-query-params";

export type TrainingResourceViewMode = "document-view" | "mobile-view";

export const TRAINING_RESOURCE_VIEW_MODE_OPTIONS: Option<TrainingResourceViewMode>[] =
  [
    { label: "Document", value: "document-view", icon: "file" },
    { label: "Mobile", value: "mobile-view", icon: "iphone" },
  ];

type Return = {
  trainingResourceViewMode: TrainingResourceViewMode | null | undefined;
  setTrainingResourceViewMode: (value: TrainingResourceViewMode) => void;
};

const useTrainingResourceViewModeQueryParams = (): Return => {
  const [trainingResourceViewMode, setTrainingResourceViewMode] = useQueryParam(
    "training-resource-view-mode",
    withDefault(
      createEnumParam(TRAINING_RESOURCE_VIEW_MODE_OPTIONS.map((x) => x.value)),
      "document-view",
    ),
  );
  return useMemo(() => {
    return { trainingResourceViewMode, setTrainingResourceViewMode };
  }, [trainingResourceViewMode, setTrainingResourceViewMode]);
};

export default useTrainingResourceViewModeQueryParams;
